import styled from "styled-components";
import { Loading } from "components";

export const StyledLoading = styled(Loading)`
  height: 100vh;
`;
